var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M416 16H96C51.84 16 16 51.84 16 96V416C16 460.16 51.84 496 96 496H416C460.16 496 496 460.16 496 416V96C496 51.84 460.16 16 416 16Z",
    fill: "url(#paint0_linear_64_9649)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M315.361 235.36C312.161 238.4 308.161 240 304.001 240C299.841 240 295.841 238.4 292.641 235.36L272.001 214.56V336C272.001 344.8 264.801 352 256.001 352C247.201 352 240.001 344.8 240.001 336V214.56L219.361 235.2C213.121 241.44 203.041 241.44 196.801 235.2C190.561 228.96 190.561 218.88 196.801 212.64L244.801 164.64C246.241 163.2 247.841 162.24 249.601 161.44L251.041 160.96C252.481 160.48 253.761 160.16 255.201 160.16C255.681 160.16 256.161 160 256.641 160.16C258.401 160.16 260.161 160.48 261.761 161.12C261.921 161.12 262.081 161.12 262.241 161.28C264.001 162.08 265.601 163.2 266.881 164.48C267.041 164.64 267.201 164.64 267.361 164.8L315.361 212.8C321.601 218.88 321.601 229.12 315.361 235.36Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_64_9649",
    x1: 39.456,
    y1: 472.544,
    x2: 472.544,
    y2: 39.456,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#589ff3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.416,
    stopColor: "#589ff3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9973,
    stopColor: "#589ff3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpArrow);
export default __webpack_public_path__ + "static/media/up-arrow.9127cbbc3f606577cf82b7e66276bd27.svg";
export { ForwardRef as ReactComponent };